import { reatomBoolean } from "@reatom/framework";
import { withLocalStorage } from "@reatom/persist-web-storage";

export const filtersModalAtom = reatomBoolean(false, "filtersModal").pipe(
  withLocalStorage("filtersModal"),
);
